import { create } from 'zustand';
import { getFavoriteProperties } from '../utils/favourites';
import useTokenStore from './store';

interface FavoriteProperty {
  _id: string;
  propertyOf: string;
  price: number;
  images: Array<{ url: string }>;
  bedrooms: number;
  buildingUnits?: number;
  region: string;
  strategy: string;
  tenureType: string;
  occupancy: string;
  discountToMarket: number;
  rentGrossYield: number;
  estimatedValue: number;
  investment: number;
  averageRent: number;
  reserved: boolean;
}

interface FavoritesStore {
  favorites: FavoriteProperty[];
  favoriteIds: string[];
  isLoading: boolean;
  error: string | null;
  fetchFavorites: () => Promise<void>;
  removeFavorite: (propertyId: string) => void;
}

export const useFavoritesStore = create<FavoritesStore>((set) => ({
  favorites: [],
  favoriteIds: [],
  isLoading: false,
  error: null,
  fetchFavorites: async () => {
    const token = useTokenStore.getState().token;
    if (!token) return;

    set({ isLoading: true, error: null });
    try {
      const response = await getFavoriteProperties(token);
      if (response.status === 200) {
        set({
          favorites: response.results,
          favoriteIds: response.favoriteIds,
          isLoading: false
        });
      } else {
        set({ error: response.message, isLoading: false });
      }
    } catch (error) {
      set({ error: 'Failed to fetch favorites', isLoading: false });
    }
  },
  removeFavorite: (propertyId: string) => {
    set((state) => ({
      favorites: state.favorites.filter(property => property._id !== propertyId),
      favoriteIds: state.favoriteIds.filter(id => id !== propertyId)
    }));
  }
})); 